<template>
    <div v-bind:class="centerClass">
        <div v-bind:class="containerClass">
            <slot>
                <div v-bind:class="iconClass" />
            </slot>
        </div>
    </div>
</template>
<script>
    import { ENVELOPE_ITEM_TYPE } from "ESignatures/EditEnvelope/editEnvelopeStore";
    export const ENVELOPE_ICON_TYPE = {
        spacer: "", // No image; just for spacing purposes
        attachment: "attachment",
        contentItem: "contentItem",
        documentTemplate: "documentTemplate",
        fieldsGroup: "fieldsGroup",
        fieldsIndividual: "fieldsIndividual",
        fixedRecipient: "fixedRecipient",
        nestedItem: "nestedItem",
        personMultiple: "personMultiple",
        twoWayArrow: "twoWayArrow"
    };

    export function getIconTypeForItemType(itemTypeId) {
        switch (itemTypeId) {
            case ENVELOPE_ITEM_TYPE.Attachment:
                return ENVELOPE_ICON_TYPE.attachment;
            case ENVELOPE_ITEM_TYPE.ContentItem:
                return ENVELOPE_ICON_TYPE.contentItem;
            case ENVELOPE_ITEM_TYPE.DocumentTemplate:
                return ENVELOPE_ICON_TYPE.documentTemplate;
            default:
                throw `Unrecognized item type ${this.type}`;
        }
    }

    export default {
        props: {
            size: { type: String, required: false, default: "md" },
            type: { type: String, required: false, default: "" },
            primary: { type: Boolean, required: false, default: true },
            center: { type: Boolean, required: false, default: true }
        },
        computed: {
            containerClass() {
                return `icon-container-${this.size}`;
            },
            centerClass() {
                return {
                    "d-flex": this.center,
                    "align-items-center": this.center,
                    "justify-content-center": this.center
                };
            },
            iconClass() {
                const iconImageClass = `icon-${this.type}`;
                return {
                    [iconImageClass]: this.type ? iconImageClass : false,
                    "icon-primary": this.primary && this.usingMaskImage,
                    "icon-black": !this.primary && this.usingMaskImage
                };
            },
            // If using this without a type, might just be using it for spacing/size, in which
            // case it may not be appropriate to set the bg-color
            usingMaskImage() {
                return Boolean(this.type);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .icon-container-sm {
        height: 1rem;
        width: 1rem;
        font-size: 1rem;
    }

    .icon-container-md {
        height: calc(1.5rem);
        width: calc(1.5rem);
        font-size: calc(1.5rem);
    }

    .icon-container-lg {
        height: calc(2rem);
        width: calc(2rem);
        font-size: calc(2rem);
    }

    .icon-container-xl {
        height: calc(3rem);
        width: calc(3rem);
        font-size: calc(3rem);
    }

    .icon-black {
        background-color: var(--bs-black);
    }

    .icon-primary {
        background-color: var(--bs-primary);
    }

    %icon-shared {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
    }

    // Must correspond to the actual filenames of these images
    $icon-images:
        attachment, contentItem, documentTemplate, fieldsGroup, fieldsIndividual, fixedRecipient, nestedItem,
        personMultiple, twoWayArrow;

    @each $image in $icon-images {
        .icon-#{$image} {
            @extend %icon-shared;
            mask-image: url(Images/icons/eSignatureEnvelopeEditor/#{$image}.svg);
            mask-size: 100%;
            mask-position: center;
            mask-repeat: no-repeat;
        }
    }
</style>
